import { createApiClient } from "../apiClientFactory";
import axios from "axios";
import type {
  GetProgressDebugRequest,
  GetProgressDebugResponse,
} from "./level-test-progress.interfaces";

// Client HTTP configurado para level-tests
const apiClient = createApiClient('level-tests');

/**
 * API real para obter dados de debug do progresso do Level Test
 * Endpoint: GET /api/level-tests/session/{sessionId}/progress-debug
 */
export const apiGetProgressDebug = async (
  request: GetProgressDebugRequest
): Promise<GetProgressDebugResponse> => {
  try {
    const response = await apiClient.get<GetProgressDebugResponse>(
      `/level-tests/session/${request.sessionId}/progress-debug`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // Expected when LevelTest:DebugEnabled=false in production
      throw error;
    }
    console.error('[API] apiGetProgressDebug - Error:', error);
    throw error;
  }
};

